import { IAuthService } from "../platform/services/auth/AuthService";
import {User} from "./typescript/interfaces";

export const getCurrentUser = async (authService: IAuthService): Promise<User | undefined> => {
    const user = await authService.getCurrentUser();
    return user || undefined;
}

export const getCurrentUserIdToken = async (authService: IAuthService) => {
    try {
        const { idToken } = (await authService.fetchAuthSession()).tokens ?? {};
        return idToken?.toString();
    } catch (error) {
        return undefined;
    }
}

// Legacy functions for backward compatibility - will be deprecated
// @deprecated Use authService.getCurrentUser() instead
export const getCurrentUserAmplify = async () => {
    throw new Error('getCurrentUserAmplify is deprecated. Use authService.getCurrentUser() instead.');
};
